<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "DebtTransfer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/DebtTransfer.vue